import { c as _c } from "react/compiler-runtime";
import { BarWrapper } from './bar-wrapper';
const MobileBarsValues = [{
  height: 148
}, {
  height: 150
}, {
  height: 155
}, {
  height: 139
}, {
  height: 150
}, {
  height: 156
}, {
  height: 162
}, {
  height: 166
}, {
  height: 164,
  heightRelative: 13
}, {
  height: 162,
  heightRelative: 23
}, {
  height: 169,
  heightRelative: 53
}, {
  height: 168,
  heightRelative: 48
}];
const TabletBarsValues = [{
  height: 195
}, {
  height: 195
}, {
  height: 196
}, {
  height: 180
}, {
  height: 185
}, {
  height: 192
}, {
  height: 197
}, {
  height: 208
}, {
  height: 211,
  heightRelative: 13
}, {
  height: 215,
  heightRelative: 23
}, {
  height: 220,
  heightRelative: 53
}, {
  height: 228,
  heightRelative: 48
}];
const DeskBarsValues = [{
  height: 245
}, {
  height: 244
}, {
  height: 246
}, {
  height: 226
}, {
  height: 256
}, {
  height: 264
}, {
  height: 273
}, {
  height: 286
}, {
  height: 291,
  heightRelative: 13
}, {
  height: 297,
  heightRelative: 23
}, {
  height: 303,
  heightRelative: 53
}, {
  height: 308,
  heightRelative: 48
}];
function BarSkeletonItems() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-full flex-row items-end justify-between gap-2 md:hidden">{MobileBarsValues.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="hidden w-full flex-row items-end justify-between gap-1 md:flex lg:gap-2 xl:hidden">{TabletBarsValues.map(_temp2)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex w-full flex-row gap-2 xl:gap-6">{t0}{t1}<div className="hidden flex-row items-end gap-[19px] xl:flex 2xl:gap-6">{DeskBarsValues.map(_temp3)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp3(item_1, index_1) {
  return <BarWrapper key={index_1} height={item_1.height} heightRelative={item_1.heightRelative} className="w-10" />;
}
function _temp2(item_0, index_0) {
  return <BarWrapper key={index_0} height={item_0.height} heightRelative={item_0.heightRelative} className="w-6 lg:w-7.5" />;
}
function _temp(item, index) {
  return <BarWrapper key={index} height={item.height} heightRelative={item.heightRelative} />;
}
export { BarSkeletonItems };